var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * WarningDiamond component
 * @csspart base - The component's base wrapper.
 */
export class BlocksIconWarningDiamond extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.3065 10.2854L13.7145 1.68682C12.7995 0.771059 11.2102 0.771059 10.2951 1.68682L1.70315 10.2854C1.25044 10.7384 1 11.3457 1 11.9916C1 12.6374 1.25044 13.2447 1.70315 13.6978L10.2951 22.2963C10.7671 22.7687 11.3835 23 12 23C12.6165 23 13.2329 22.7687 13.7049 22.2963L22.2968 13.6978C22.7496 13.2447 23 12.6374 23 11.9916C23 11.3457 22.7496 10.7384 22.2968 10.2854H22.3065ZM21.2855 12.6856L12.6935 21.2842C12.3179 21.6601 11.7014 21.6601 11.3161 21.2842L2.72417 12.6856C2.34851 12.3097 2.34851 11.6927 2.72417 11.3072L11.3257 2.70862C11.5184 2.51583 11.7592 2.42907 12.0096 2.42907C12.2601 2.42907 12.5105 2.52547 12.6935 2.70862L21.2855 11.3072C21.6611 11.6831 21.6611 12.3 21.2855 12.6856ZM12.0095 13.1194C12.4044 13.1194 12.7319 12.7916 12.7319 12.3964V7.24886C12.7319 6.85364 12.4044 6.52589 12.0095 6.52589C11.6146 6.52589 11.2871 6.85364 11.2871 7.24886V12.3964C11.2871 12.7916 11.6146 13.1194 12.0095 13.1194ZM13.4541 16.3487C13.4541 17.1473 12.8072 17.7946 12.0093 17.7946C11.2113 17.7946 10.5645 17.1473 10.5645 16.3487C10.5645 15.5501 11.2113 14.9027 12.0093 14.9027C12.8072 14.9027 13.4541 15.5501 13.4541 16.3487Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconWarningDiamond.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningDiamond.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconWarningDiamond.prototype, "size", void 0);
if (customElements.get('cat-icon-warning-diamond') === undefined) {
    customElements.define('cat-icon-warning-diamond', BlocksIconWarningDiamond);
}
